import { render, staticRenderFns } from "./BottomFooter.vue?vue&type=template&id=14cefc96&scoped=true&"
import script from "./BottomFooter.vue?vue&type=script&lang=js&"
export * from "./BottomFooter.vue?vue&type=script&lang=js&"
import style0 from "./BottomFooter.vue?vue&type=style&index=0&id=14cefc96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cefc96",
  null
  
)

export default component.exports